<div class="report-container">
  <!-- Metadata Section with Collapse and Action Buttons next to Title -->
  <div class="metadata-section" title="Generated: {{ formatValue(metadata.timestamp, 'date') }}" >
    <div class="section-header" style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center; gap: 0.5rem;">
        @if (sections.length > 0) {
          <button class="collapse-toggle" (click)="sectionHeaderCollapsed = !sectionHeaderCollapsed" [title]="sectionHeaderCollapsed ? 'Expand Section Header' : 'Collapse Section Header'">
            <i class="fa" [ngClass]="sectionHeaderCollapsed ? 'fa-expand' : 'fa-compress'"></i>
          </button>
        }
        <h2 style="margin: 0;">{{ reportTitle }}</h2>
        <button (click)="printReport()" title="Print" class="icon-btn"><i class="fa fa-print"></i></button>
        <button (click)="downloadCSV()" title="Download CSV" class="icon-btn"><i class="fa fa-download"></i></button>
      </div>
    </div>

    <!-- <ng-container *ngIf="!sectionHeaderCollapsed && sections.length > 0">
    <div class="metadata-grid">
      <div class="metadata-item" *ngFor="let section of sections">
        <div class="metadata-label">{{ section.title }}</div>
        <div class="metadata-value">{{ metadata[section.key] }}</div>
      </div>
    </div>
    <table class="metadata-table print-only">
      <tr>
        <th *ngFor="let section of sections">{{ section.title }}</th>
      </tr>
      <tr>
        <td *ngFor="let section of sections">{{ metadata[section.key] }}</td>
      </tr>
    </table>
  </ng-container> -->
</div>

<!-- Key Insights Section (collapsible, below metadata) -->
@if (data && data.insights && data.insights.length > 0) {
  <div class="summary-section insights-collapsible" style="margin-bottom: 1rem;">
    <div class="section-header" style="display: flex; align-items: center; justify-content: space-between; padding-bottom: 0;">
      <div style="display: flex; align-items: center; gap: 0.5rem;">
        <button class="collapse-toggle" (click)="insightsCollapsed = !insightsCollapsed" [title]="insightsCollapsed ? 'Expand Key Insights' : 'Collapse Key Insights'">
          <i class="fa" [ngClass]="insightsCollapsed ? 'fa-expand' : 'fa-compress'"></i>
        </button>
        <h2 style="margin: 0; font-size: 1.2rem; display: flex; align-items: center; padding-left: 0.2rem;">
          <i class="fas fa-lightbulb text-warning" style="margin-right: 8px;"></i>
          Key Insights
        </h2>
      </div>
    </div>
    @if (!insightsCollapsed) {
      <ul class="insights-list" style="margin-top: 10px; padding-left: 2.2rem;">
        @for (point of data.insights; track point) {
          <li>
            <i class="fas fa-lightbulb text-warning"></i>
            <span>{{ point }}</span>
          </li>
        }
      </ul>
    }
  </div>
}

<!-- Data Table Section -->
@if (leafColumns.length > 0) {
  <div class="table-section">
    <div class="table-container" [class.pinned]="pinHeaderFooter">
      <table class="data-table">
        <thead [class.pinned]="pinHeaderFooter">
          <tr>
            <th>
              No
              <button (click)="togglePinHeaderFooter()" [title]="pinHeaderFooter ? 'Unpin Header/Footer' : 'Pin Header/Footer'" class="icon-btn pin-btn">
                <i class="fa fa-thumb-tack" [ngStyle]="pinHeaderFooter ? {'transform': 'rotate(-45deg)', 'color': '#e74c3c'} : {}"></i>
              </button>
            </th>
            @for (col of leafColumns; track col; let i = $index) {
              <th
                [class.numeric]="isNumericColumn(col)"
                [class.date]="col.type === 'date'">
                {{ col.title }}
              </th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of pagedData; track row; let rowIdx = $index) {
            <tr>
              <td>{{ (pageNo - 1) * pageSize + rowIdx + 1 }}</td>
              @for (col of leafColumns; track col; let i = $index) {
                <td
                  [class.numeric]="isNumericColumn(col)"
                  [class.date]="col.type === 'date'">
                  {{ formatValue(getValue(row, col.key), col.type) }}
                </td>
              }
            </tr>
          }
        </tbody>
        <tfoot [ngClass]="{'pinned-footer': pinHeaderFooter}">
          @if (hasNumericColumns) {
            <tr class="totals-row">
              <td></td>
              @for (col of leafColumns; track col; let i = $index) {
                <td
                  [class.numeric]="isNumericColumn(col)"
                  [class.date]="col.type === 'date'">
                  {{ getColumnTotal(col) }}
                </td>
              }
            </tr>
          }
        </tfoot>
      </table>
    </div>
    <!-- Pagination Controls -->
    <div class="pagination-controls">
      <button (click)="goToFirst()" [disabled]="pageNo === 1" title="First Page"><span class="icon-first"></span></button>
      <button (click)="goToPrev()" [disabled]="pageNo === 1" title="Previous Page"><span class="icon-prev"></span></button>
      <span>Page</span>
      <input type="number" min="1" [max]="totalPages" [(ngModel)]="inputPageNo" (blur)="onPageInputBlur()" (keyup.enter)="onPageInputEnter()" [disabled]="pageSize === -1">
      <span>of {{ totalPages }}</span>
      <button (click)="goToNext()" [disabled]="pageNo === totalPages || pageSize === -1" title="Next Page"><span class="icon-next"></span></button>
      <button (click)="goToLast()" [disabled]="pageNo === totalPages || pageSize === -1" title="Last Page"><span class="icon-last"></span></button>
      <span>| Show</span>
      <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange(+($event))">
        @for (size of pageSizes; track size) {
          <option [value]="size">{{ size }}</option>
        }
        <option [value]="-1">All</option>
      </select>
      <span>per page</span>
      <span style="margin-left:auto;">Total: {{ tableData.length }}</span>
    </div>
  </div>
}
</div>